import { useState } from "react"
import { array, string } from "prop-types"
import { apiAsync as api } from "utils/api"
import { Box, Button } from "@planningcenter/tapestry-react"
import { SettingPane, useSettings, SettingContextProvider } from "./SettingPane"

const NotificationListSettings = ({ recipients: recipientsFromProps, eventNotificationsPath }) => {
  const { isEditing, onEditing, onSaving, onSuccess, onError, onCancel } = useSettings()
  const [recipientsToSave, setRecipientsToSave] = useState(recipientsFromProps.join(", "))
  const [recipients, setRecipients] = useState(recipientsFromProps)

  const handleCancel = () => {
    setRecipients(recipients)
    setRecipientsToSave(recipients.join(", "))
    onCancel()
  }

  const handleSave = async () => {
    onSaving(true)
    const invalid =
      recipientsToSave.trim().length === 0
        ? []
        : recipientsToSave.split(",").filter(r => !r.trim().match(/^[^\s]+@[^\s]+\.[^\s]+$/i))

    if (invalid.length > 0) return onError("Email address is invalid")

    const response = await api.put(eventNotificationsPath, {
      event: { notification_list: recipientsToSave }
    })

    if (response.errors) {
      onError(response.errors)
    } else {
      setRecipients(response.recipients)
      onSuccess()
    }
  }

  const handleChange = ({ target: { value } }) => setRecipientsToSave(value)

  return (
    <SettingPane
      title="Notification list"
      onSave={handleSave}
      onCancel={handleCancel}
      blankState={
        !isEditing &&
        recipients.length === 0 && (
          <>
            You can specify who is notified by email when people register on Church Center.
            <Box marginTop={1}>
              <Button
                title="Edit notification list"
                theme="app"
                size="sm"
                onClick={() => onEditing(true)}
              />
            </Box>
          </>
        )
      }
    >
      {!isEditing && recipients.length > 0 && (
        <>
          {recipients.map(r => (
            <div key={r}>{r}</div>
          ))}
        </>
      )}

      {isEditing && (
        <>
          <textarea id="notification_list" value={recipientsToSave} onChange={handleChange} />
          <p className="font-size-4 c-neutral-600 mb-0 mt-1">
            Enter email addresses separated by a comma, e.g.{" "}
            <em>support@planningcenter.com, pico@planningcenter.com</em>
          </p>
        </>
      )}
    </SettingPane>
  )
}

NotificationListSettings.propTypes = {
  recipients: array,
  eventNotificationsPath: string
}

const NotificationList = props => {
  return (
    <SettingContextProvider>
      <NotificationListSettings {...props} />
    </SettingContextProvider>
  )
}

export default NotificationList
